import { useWindowSize } from 'hooks/useWindowSize';

import React, { ReactNode } from 'react';

import { Text } from '@thinkific/chalk/Text';

import { useCommunityContext } from 'components/CommunityContext';
import { NotificationPane } from 'components/NotificationPane';
import UserAvatar from 'components/UserAvatar';

import Breadcrumb from './Breadcrumb';
import * as css from './ContextHeader.css';

interface ContextHeaderProps {
  pageTitle: ReactNode;
  breadcrumb?: {
    url: string;
    onClick: (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  };
  classNames?: string;
  action?: ReactNode;
  showProfile?: boolean;
}

export const ContextHeader = ({
  pageTitle,
  breadcrumb,
  classNames,
  action,
  showProfile = true,
}: ContextHeaderProps) => {
  const { currentUser, inLearnerHub } = useCommunityContext();
  const { isMobile } = useWindowSize();

  const title =
    typeof pageTitle === 'string' ? (
      <Text as="h2" variant={isMobile ? 'display.md' : 'display.sm'}>
        {pageTitle}
      </Text>
    ) : (
      pageTitle
    );

  return (
    <header className={`${css.container} ${classNames}`} data-qa="top-bar">
      <div className={css.titleContainer}>
        {breadcrumb && typeof pageTitle === 'string' ? (
          <Breadcrumb pageTitle={pageTitle} url={breadcrumb.url} onClick={breadcrumb.onClick} />
        ) : (
          title
        )}
      </div>

      {action}
      {showProfile && !inLearnerHub && (
        <>
          <NotificationPane />
          <UserAvatar
            size="xs"
            {...currentUser}
            userId={currentUser.id}
            username={currentUser.fullName}
            shouldOpenSideMenu
          />
        </>
      )}
    </header>
  );
};

export default ContextHeader;
